<template>
  <v-container fluid pa-5>
    <!-- <v-layout
      row
      wrap
      ma-0
    >
      <v-flex
        xs12
        mb-3
      >
        <p class="title text-left primary--text font-weight-medium">
          ข้อมูลอุบัติเหตุ
        </p>
        <v-divider></v-divider>
      </v-flex>
    </v-layout>-->
    <v-layout row wrap ma-0>
      <v-flex xs12 sm6 pr-2>
        <!-- 1 -->
        <v-layout row wrap ma-0>
          <v-flex class="d-flex flex-row" xs12>
            <div>
              <div class="topic-number d-flex justify-center align-center white--text">1</div>
            </div>
            <div class="d-flex align-self-center">
              <p class="body-2 font-weight-medium mb-0 ml-2 d-flex align-self-center">วันและเวลา</p>
            </div>
          </v-flex>
          <v-flex class="d-flex flex-row" xs12 pt-3>
            <v-layout row wrap ma-0>
              <v-flex
                :class="{
                  xs6: $vuetify.breakpoint.width >= 400,
                  'pr-1': $vuetify.breakpoint.width >= 400,
                  xs12: $vuetify.breakpoint.width < 400
                }"
                sm6
                mt-2
              >
                <p class="body-2 font-weight-medium mb-1 d-flex align-self-center">วัน</p>
                <v-text-field
                  v-model="date"
                  hide-details
                  class="card-border"
                  clearable
                  my-auto
                  solo
                  flat
                  readonly
                ></v-text-field>
              </v-flex>
              <v-flex
                :class="{
                  xs6: $vuetify.breakpoint.width >= 400,
                  'pl-1': $vuetify.breakpoint.width >= 400,
                  xs12: $vuetify.breakpoint.width < 400,
                  'mt-2': $vuetify.breakpoint.width < 400
                }"
                sm6
                mt-2
              >
                <p class="body-2 font-weight-medium mb-1 d-flex align-self-center">เวลา</p>
                <v-text-field
                  v-model="time"
                  hide-details
                  class="card-border"
                  clearable
                  my-auto
                  solo
                  flat
                  readonly
                ></v-text-field>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
        <!-- 2 -->
        <v-layout row wrap ma-0 mt-5>
          <v-flex class="d-flex flex-row" xs12>
            <div>
              <div class="topic-number d-flex justify-center align-center white--text">2</div>
            </div>
            <div class="d-flex align-self-center">
              <p class="body-2 font-weight-medium mb-0 ml-2 d-flex align-self-center">
                ตำแหน่งและสถานที่เกิดเหตุ
              </p>
            </div>
          </v-flex>
          <v-flex class="d-flex flex-row" xs12 pt-3>
            <DoubleColumnForm
              :dataSource="form2"
              textName="label"
              textValue="value"
              textModel="model"
              readonly
            />
          </v-flex>
          <v-flex class="d-flex flex-row map" xs12 pt-3 v-if="$vuetify.breakpoint.xsOnly">
            <longdo-map :mapOptions="mapOptions" @onload="initMap" />
          </v-flex>
        </v-layout>
        <!-- 3 -->
        <v-layout row wrap ma-0 mt-5>
          <v-flex class="d-flex flex-row" xs12>
            <div>
              <div class="topic-number d-flex justify-center align-center white--text">3</div>
            </div>
            <div class="d-flex align-self-center">
              <p class="body-2 font-weight-medium mb-0 ml-2 d-flex align-self-center">
                สิ่งแวดล้อม
              </p>
            </div>
          </v-flex>
          <v-flex class="d-flex flex-row" xs12 pt-3>
            <DoubleColumnForm
              :dataSource="form3"
              textName="label"
              textValue="value"
              textModel="model"
              readonly
            />
          </v-flex>
        </v-layout>
        <!-- 4 -->
        <v-layout row wrap ma-0 mt-5>
          <v-flex class="d-flex flex-row" xs12>
            <div>
              <div class="topic-number d-flex justify-center align-center white--text">4</div>
            </div>
            <div class="d-flex align-self-center">
              <p class="body-2 font-weight-medium mb-0 ml-2 d-flex align-self-center">
                สาเหตุ (มูลเหตุสันนิษฐาน)
              </p>
            </div>
          </v-flex>
          <v-flex class="d-flex flex-row" xs12 pt-3>
            <DoubleColumnForm
              :dataSource="form4"
              textName="label"
              textValue="value"
              textModel="model"
              readonly
            />
          </v-flex>
        </v-layout>
      </v-flex>
      <v-flex xs12 sm6 pl-2>
        <!-- Map -->
        <v-layout row wrap ma-0>
          <v-flex class="d-flex flex-row hidden" xs12>
            <div>
              <div class="topic-number d-flex justify-center align-center white--text">0</div>
            </div>
            <div class="d-flex align-self-center">
              <p class="body-2 font-weight-medium mb-0 ml-2 d-flex align-self-center">Map</p>
            </div>
          </v-flex>
          <v-flex class="d-flex flex-row map" xs12 pt-3 v-if="$vuetify.breakpoint.smAndUp">
            <longdo-map :mapOptions="mapOptions" @onload="initMap" />
          </v-flex>
        </v-layout>
        <!-- 5 -->
        <v-layout row wrap ma-0 mt-5>
          <v-flex class="d-flex flex-row" xs12>
            <div>
              <div class="topic-number d-flex justify-center align-center white--text">5</div>
            </div>
            <div class="d-flex align-self-center">
              <p class="body-2 font-weight-medium mb-0 ml-2 d-flex align-self-center">
                ลักษณะการชน
              </p>
            </div>
          </v-flex>
          <v-flex class="d-flex flex-row" xs12 pt-3>
            <v-layout row wrap ma-0>
              <v-flex
                :class="{
                  xs6: $vuetify.breakpoint.width >= 400,
                  'pr-1': $vuetify.breakpoint.width >= 400,
                  xs12: $vuetify.breakpoint.width < 400
                }"
                sm6
                mt-2
              >
                <p class="body-2 font-weight-medium mb-1 d-flex align-self-center">รูปแบบการชน</p>
                <v-text-field
                  v-model="crashType"
                  hide-details
                  class="card-border"
                  clearable
                  my-auto
                  solo
                  flat
                  readonly
                ></v-text-field>
              </v-flex>
              <v-flex
                :class="{
                  xs6: $vuetify.breakpoint.width >= 400,
                  'pl-1': $vuetify.breakpoint.width >= 400,
                  xs12: $vuetify.breakpoint.width < 400,
                  'mt-2': $vuetify.breakpoint.width < 400
                }"
                sm6
                mt-2
                class="d-flex"
              >
                <div class="image-container d-flex align-end">
                  <div v-for="num in 2" :key="`image-${num}`">
                    <v-img
                      width="55"
                      src="https://picsum.photos/id/11/500/300"
                      class="thumb-img"
                      :aspect-ratio="1 / 1"
                    ></v-img>
                  </div>
                </div>
              </v-flex>
              <v-flex xs12 mt-2>
                <p class="body-2 font-weight-medium mb-1 d-flex align-self-center">
                  รายงานเหตุการณ์โดยย่อ
                </p>
                <v-textarea
                  v-model="crashTypeDescription"
                  hide-hint
                  :auto-grow="true"
                  clearable
                  my-auto
                  solo
                  flat
                  class="card-border"
                ></v-textarea>
              </v-flex>
              <v-flex xs12 mt-1 mb-2>
                <!-- <VehicleFormDialog title="คนและยานพาหนะ" /> -->
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
        <!-- 6 -->
        <v-layout row wrap ma-0 mt-5>
          <v-flex class="d-flex flex-row" xs12>
            <div>
              <div class="topic-number d-flex justify-center align-center white--text">6</div>
            </div>
            <div class="d-flex align-self-center">
              <p class="body-2 font-weight-medium mb-0 ml-2 d-flex align-self-center">
                เหตุบริเวณใกล้เคียงช่วง 3 ปี
              </p>
            </div>
          </v-flex>
          <v-flex class="d-flex flex-row" xs12 pt-3>
            <v-layout row wrap ma-0>
              <v-flex xs12 mt-2>
                <v-simple-table class="card-border">
                  <template v-slot:default>
                    <thead class="lightgrey">
                      <tr>
                        <th class="text-center font-weight-regular">วันที่</th>
                        <th class="text-center font-weight-regular">ความรุนแรง</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="item in accidentRecords" :key="item.name">
                        <td>{{ item.date }}</td>
                        <td>{{ item.severity }}</td>
                      </tr>
                    </tbody>
                  </template>
                </v-simple-table>
              </v-flex>
              <v-flex xs12 mt-2 pt-2>
                <highcharts :options="pieOptions" />
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
      </v-flex>
      <v-flex xs12>
        <v-layout row wrap ma-0>
          <v-flex class="d-flex flex-row" xs12>
            <div>
              <div class="topic-number d-flex justify-center align-center white--text">7</div>
            </div>
            <div class="d-flex align-self-center">
              <p class="body-2 font-weight-medium mb-0 ml-2 d-flex align-self-center">
                สรุปความเสียหาย
              </p>
            </div>
          </v-flex>
          <v-flex xs12 sm6 pr-sm-2 pt-2>
            <v-simple-table class="card-border mt-4">
              <template v-slot:default>
                <thead class="lightgrey">
                  <tr>
                    <th colspan="2" class="text-left font-weight-regular">
                      จำนวนผู้เสียชีวิต ณ จุดเกิดเหตุ
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="item in suddenlyDeadAmount" :key="item.name">
                    <td class="text-left pl-10">{{ item.name }}</td>
                    <td class="text-center">{{ item.amount }}</td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>

            <v-simple-table class="card-border mt-4">
              <template v-slot:default>
                <thead class="lightgrey">
                  <tr>
                    <th colspan="2" class="text-left font-weight-regular">จำนวนผู้บาดเจ็บสาหัส</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="item in hardInjuryAmount" :key="item.name">
                    <td class="text-left pl-10">{{ item.name }}</td>
                    <td class="text-center">{{ item.amount }}</td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
          </v-flex>
          <v-flex xs12 sm6 pl-sm-2 pt-2>
            <v-simple-table class="card-border mt-4">
              <template v-slot:default>
                <thead class="lightgrey">
                  <tr>
                    <th colspan="2" class="text-left font-weight-regular">
                      จำนวนผู้เสียชีวตหลังเกิดเหตุ
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="item in deadLaterAmount" :key="item.name">
                    <td class="text-left pl-10">{{ item.name }}</td>
                    <td class="text-center">{{ item.amount }}</td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>

            <v-simple-table class="card-border mt-4">
              <template v-slot:default>
                <thead class="lightgrey">
                  <tr>
                    <th colspan="2" class="text-left font-weight-regular">
                      จำนวนผู้บาดเจ็บเล็กน้อย
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="item in softInjuryAmount" :key="item.name">
                    <td class="text-left pl-10">{{ item.name }}</td>
                    <td class="text-center">{{ item.amount }}</td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
          </v-flex>
        </v-layout>
      </v-flex>
      <!-- <v-flex class="d-flex flex-column flex-sm-row align-end mt-10">
        <v-btn
          :block="$vuetify.breakpoint.xsOnly"
          rounded
          outlined
          width="120"
          color="primary"
          class="mt-2"
          @click="printDetail"
        >
          พิมพ์รายงาน
        </v-btn>
        <v-spacer></v-spacer>
        <v-btn
          :block="$vuetify.breakpoint.xsOnly"
          rounded
          width="120"
          color="primary"
          class="mt-2 ml-2"
        >
          ปิด
        </v-btn>
      </v-flex>-->
    </v-layout>
  </v-container>
</template>

<script>
// import DatePicker from '../global/DatePicker.vue';
// import TimePicker from '../global/TimePicker.vue';
// import Form1 from './Form1.vue';
// import Form2 from './Form2.vue';
// import FormImage from './FormImage.vue';
import DoubleColumnForm from './DoubleColumnForm.vue';
import VehicleFormDialog from '../global/VehicleFormDialog.vue';

export default {
  name: 'Default',
  components: {
    // DatePicker,
    // TimePicker,
    // Form1,
    // Form2,
    // FormImage,
    DoubleColumnForm,
    VehicleFormDialog
  },
  data: () => ({
    accidentRecords: [
      {
        date: '12 เมษายน 2561',
        severity: 'เสียชีวิต 1 ราย'
      },
      {
        date: '10 เมษายน 2561 ',
        severity: 'บาดเจ็บสาหัส 2 ราย '
      },
      {
        date: '11 เมษายน 2562 ',
        severity: 'บาดเจ็บสาหัส 1 ราย '
      }
    ],
    suddenlyDeadAmount: [
      {
        name: 'ชาย - ผู้ใหญ่',
        amount: '0'
      },
      {
        name: 'ชาย - เด็ก',
        amount: '0'
      },

      {
        name: 'หญิง - ผู้ใหญ่',
        amount: '0'
      },
      {
        name: 'หญิง - เด็ก',
        amount: '0'
      }
    ],
    deadLaterAmount: [
      {
        name: 'ชาย - ผู้ใหญ่',
        amount: '0'
      },
      {
        name: 'ชาย - เด็ก',
        amount: '0'
      },

      {
        name: 'หญิง - ผู้ใหญ่',
        amount: '0'
      },
      {
        name: 'หญิง - เด็ก',
        amount: '0'
      }
    ],
    hardInjuryAmount: [
      {
        name: 'ชาย - ผู้ใหญ่',
        amount: '0'
      },
      {
        name: 'ชาย - เด็ก',
        amount: '0'
      },

      {
        name: 'หญิง - ผู้ใหญ่',
        amount: '0'
      },
      {
        name: 'หญิง - เด็ก',
        amount: '0'
      }
    ],
    softInjuryAmount: [
      {
        name: 'ชาย - ผู้ใหญ่',
        amount: '0'
      },
      {
        name: 'ชาย - เด็ก',
        amount: '0'
      },

      {
        name: 'หญิง - ผู้ใหญ่',
        amount: '0'
      },
      {
        name: 'หญิง - เด็ก',
        amount: '0'
      }
    ],
    map: {},
    mapOptions: {
      ui: false,
      zoomRange: {
        max: 18,
        min: 3
      }
    },
    //
    date: '',
    time: '',
    form2: [
      {
        label: 'ประเภทสายทาง / ถนน / หน่วยงาน',
        model: '',
        value: ''
      },
      {
        label: 'หมายเลขสายทาง',
        model: '',
        value: ''
      },
      {
        label: 'ชื่อสายทาง',
        model: '',
        value: ''
      },
      {
        label: 'กิโลเมตรที่เกิดเหตุ',
        model: '',
        value: ''
      },
      {
        label: 'ละติจูด',
        model: '',
        value: ''
      },
      {
        label: 'ลองจิจูด',
        model: '',
        value: ''
      },
      {
        label: 'จำนวนช่องจราจร',
        model: '',
        value: ''
      },
      {
        label: 'ทิศทาง',
        model: '',
        value: ''
      },
      {
        label: 'ผิวจราจร',
        model: '',
        value: ''
      },
      {
        label: 'ตำบล',
        model: '',
        value: ''
      },
      {
        label: 'อำเภอ',
        model: '',
        value: ''
      },
      {
        label: 'จังหวัด',
        model: '',
        value: ''
      },
      {
        label: 'ลักษณะบริเวณ',
        model: '',
        value: ''
      },
      {
        label: 'สภาพพิ้นผิวทางขณะเกิดเหตุ',
        model: '',
        value: ''
      },
      {
        label: 'คุณภาพพิ้นผิวทางขณะเกิดเหตุ',
        model: '',
        value: ''
      },
      {
        label: 'การควบคุมการใช้ทางบริเวณที่เกิดเหตุ',
        model: '',
        value: ''
      },
      {
        label: 'อุปกรณ์อำนวยความปลอดภัย',
        model: '',
        value: ''
      }
    ],
    form3: [
      {
        label: 'สภาพภูมิอากาศ',
        model: '',
        value: ''
      },
      {
        label: 'แสงสว่าง',
        model: '',
        value: ''
      }
    ],
    form4: [
      {
        label: 'สาเหตุด้านผู้ขับขี่',
        model: '',
        value: ''
      },
      {
        label: 'สาเหตุด้านสภาพสายทาง',
        model: '',
        value: ''
      },
      {
        label: 'สาเหตุด้านยานพาหนะ',
        model: '',
        value: ''
      },
      {
        label: 'ข้อเสนอแนะแนวทางแก้ไขเบื้องต้น',
        model: '',
        value: ''
      }
    ],
    crashType: '',
    crashTypeDescription: '',
    pieOptions: {
      chart: {
        type: 'pie'
      },
      title: {
        text: 'จำนวนอุบัติเหตุในช่วง 3 ปี',
        style: {
          fontSize: '18px',
          fontFamily: 'Sarabun'
        }
      },
      lang: {
        noData: 'ไม่มีข้อมูล'
      },
      noData: {
        style: {
          fontSize: '18px',
          fontFamily: 'Sarabun',
          fontWeight: '400',
          color: '#333333'
        }
      },
      subtitle: {
        text: 'แยกตามประเภทยานพาหนะ', // + this.countCommercialAmount,
        style: {
          fontSize: '14px',
          fontFamily: 'Sarabun'
        }
      },
      tooltip: {
        headerFormat: '<span style="font-size:11px">{series.name}</span><br/>',
        pointFormat: '{point.name}: <b>{point.y} ครั้ง</b>'
      },
      plotOptions: {
        pie: {
          cursor: 'pointer',
          showInLegend: true
        }
      },
      colors: {},
      series: [
        {
          name: 'จำนวนอุบัติเหตุ',
          dataLabels: {
            enabled: true,
            format: '<b>{point.name}</b>:<br>{point.percentage:.1f} %<br>',
            style: {
              color: 'black',
              fontSize: '14',
              'font-family': 'Sarabun',
              fontWeight: '500',
              textOutline: '0px #F5F5F5'
            }
          },
          data: [
            { name: 'eiei', y: 30 },
            { name: 'wow', y: 45 },
            { name: 'hoho', y: 25 }
          ],
          slicedOffset: 0,
          events: {
            click: data => {
              // this.chartClicked(data, 'pie');
            }
          }
        }
      ],
      credits: {
        enabled: false
      }
    }
  }),
  created() {},
  mounted() {
    this.init();
    this.initChart();
    // this.initMap();
  },
  methods: {
    init() {
      console.log(this.$vuetify.theme.themes.light);
    },
    initChart() {
      this.pieOptions.colors = [this.brownie, this.mastard, this.matcha];
    },
    initMap(map) {
      this.map = map;
      window.mapdebug = this.map;
      this.map.zoom(18);
      this.map.location({
        lat: 13.722237,
        lon: 100.529561
      });

      this.getMapLayer();
    },
    getMapLayer() {
      const self = this;
      const jsonpAdapter = require('axios-jsonp');

      const baseUrl = 'https://api.nostramap.com/Service/V2/Map/GetPermission?key=';
      const key = `${process.env.VUE_APP_NOSTRA_MAP_KEY}`;

      this.axios({
        url: baseUrl + key,
        adapter: jsonpAdapter
      }).then(response => {
        if (response.status === 200) {
          self.setBaseMap(response.data.results);
        }
      });
    },
    setBaseMap(layer) {
      const base = layer.filter(x => x.serviceID === '1');
      if (base.length === 1) {
        const nostraSteet = new window.longdo.Layer(false, {
          type: window.longdo.LayerType.ArcGIS_REST,
          url: base[0].serviceURL_L,
          key: base[0].serviceToken_L
        });

        this.map.Layers.setBase(nostraSteet);
      }
    },
    printDetail() {
      window.print();
    }
  },
  computed: {
    brownie() {
      return this.$vuetify.theme.themes.light.brownie;
    },
    mastard() {
      return this.$vuetify.theme.themes.light.mastard;
    },
    matcha() {
      return this.$vuetify.theme.themes.light.matcha;
    }
  }
};
</script>

<style lang="scss" scoped>
.container {
  padding: 0;
  background-color: white;
}

.map {
  width: 100%;
  max-height: 400px;
  height: 356px;
}

.hidden {
  visibility: hidden;
}

.thumb-img {
  border-radius: 5px;
  margin-right: 10px;
}

.image-container {
  overflow-y: auto;
}

.v-data-table thead tr th {
  font-weight: 400 !important;
}

th {
  border-bottom: 0 !important;
}

.theme--light.v-data-table tbody tr:hover:not(.v-data-table__expand-row) {
  background: var(--v-hovergrey-base);
}
</style>
